<template>
  <v-card flat class="mt-5">
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable " :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <v-data-table :headers="headers" :items-per-page="5" :items="userleverages">
          <template v-slot:item.updated_at="{ item }">
            {{ formatMySQLDate(item?.updated_at) }}
          </template>
        </v-data-table>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { LEVERAGE__ACTIONS } from "@/store/action-types";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  data() {
    return {
      headers: [
        { text: "SL.", align: "start", class: "pl-5", value: "id" },
        { text: "MT5 Account No.", value: "mt5_account_no" },
        { text: "Previous Leverage", value: "previous_leverage" },
        { text: "New Leverage", value: "present_leverage" },
        { text: "Date & Time", value: "updated_at" },

      ],
    };
  },
  computed: {
    ...mapState("leverage", ["userleverages"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    formatMySQLDate,
    ...mapActions("leverage", [
      LEVERAGE__ACTIONS.USERLEVERAGE
    ]),

  },
  async created() {
    this[LEVERAGE__ACTIONS.USERLEVERAGE](this.$route.params.id);
  },
};
</script>
